const DAY_MS = 86_400_000;

/** The time left before a pending account closure's deletion. */
export type ClosureCountdown = { today: true } | { days: number };

/**
 * Whole days until `scheduledFor`, rounded up. Under one day left, or a
 * `scheduledFor` already past, is `{ today: true }`: the deletion job runs
 * once a day, so a past stamp is due at its next run. `now` is a `Date.now()`
 * value. The member Settings card and the admin closure marker both read it,
 * so they always agree.
 */
export function closureCountdown(scheduledFor: string, now: number): ClosureCountdown {
  const remaining = Date.parse(scheduledFor) - now;
  return remaining < DAY_MS ? { today: true } : { days: Math.ceil(remaining / DAY_MS) };
}

/** {@link closureCountdown} as the phrase every closure surface ends on: "in 12 days", "in 1 day" or "today". */
export function closureTimeLeft(scheduledFor: string, now: number): string {
  const countdown = closureCountdown(scheduledFor, now);
  if ("today" in countdown) return "today";
  return `in ${countdown.days} ${countdown.days === 1 ? "day" : "days"}`;
}
